import request from '../../utils/request';

export const apiService = {
    //评分模板
    search: (data) => {
        return request({
            url: '/mark-template/querySmallCategory',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    deleteById: (data) => {
        return request({
            url: '/mark-template/deleteItem/'+data,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    //评分大类的新增和编辑
    toAddOrUpdate: (data) => {
        return request({
            url: '/mark-template/toAddItem',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //生成模板
    getTemplate: () => {
        return request({
            url: '/mark-template/getTemplate',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    //评分大类下拉
    queryCateGory: () => {
        return request({
            url: '/mark-template/queryCateGory',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    //评分模块下拉
    queryDuty: () => {
        return request({
            url: '/mark-template/queryDuty',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
}